import React from "react";
import s from "./style.module.css";
import "draft-js/dist/Draft.css";
import EditorButtons from "../EditorButtons";
import SimpleBox from "../SimpleBox";
import getDecorator from "../../helpers/getDecorator";
import replace from "../../helpers/replaceText";
import track from "../../helpers/track";
import { Editor, EditorState, ContentState } from "draft-js";
import throttle from "lodash.throttle";

class EditorSection extends React.Component {
  constructor(props) {
    super(props);

    this.updateEditorState = this.updateEditorState.bind(this);
    this.replace = this.replace.bind(this);

    const decorators = getDecorator(this.props.words, this.replace);

    this.updateTextDebounced = throttle((e) => {
      this.props.setText(e);
    }, 400);

    const content = ContentState.createFromText("");
    this.state = {
      editorState: EditorState.createWithContent(content, decorators),
    };
  }

  updateEditorState(newEditorState) {
    this.updateTextDebounced(newEditorState.getCurrentContent().getPlainText());
    this.setState({ editorState: newEditorState });
  }

  replace(blockKey, start, end, replacement) {
    const newEditorState = replace(
      this.state.editorState,
      blockKey,
      start,
      end,
      replacement
    );
    this.setState({
      editorState: newEditorState,
    });
    this.updateTextDebounced(newEditorState.getCurrentContent().getPlainText());
  }

  componentWillUpdate(nextProps) {
    if (JSON.stringify(this.props.words) !== JSON.stringify(nextProps.words)) {
      const blocks = this.state.editorState
        .getCurrentContent()
        .getBlocksAsArray()
        .map((block) => {
          const size = block.getLength();
          const key = block.getKey();
          return { size, key };
        });

      const all = blocks.reduce((arr, next, i) => {
        const isFirst = i === 0;
        const start = isFirst ? 0 : arr[i - 1].end + 1;

        arr.push({
          key: next.key,
          start,
          end: start + next.size,
          size: next.size,
        });

        return arr;
      }, []);

      const decorator = getDecorator(nextProps.words, this.replace, all);

      this.updateEditorState(
        EditorState.set(this.state.editorState, { decorator })
      );
    }
  }

  render() {
    const { copy } = this.props;

    return (
      <SimpleBox
        title={copy.title}
        flush
        extra={
          <EditorButtons
            copy={copy.buttons}
            editorState={this.state.editorState}
            update={this.updateEditorState}
          />
        }
      >
        <div className={s.editor}>
          <Editor
            placeholder={copy.initialText}
            editorState={this.state.editorState}
            onChange={this.updateEditorState}
            handlePastedText={() => {
              track.textPaste();
              return false;
            }}
          />
        </div>
      </SimpleBox>
    );
  }
}

export default EditorSection;
